import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Slider from '@mui/material/Slider';
import Input from '@mui/material/Input';


const styles = {
    slider: {
      width: '80%',
    },
    title: {
        fontFamily: 'Roboto Light',
        fontSize: 12,
      },
    markLabel: {
      fontFamily: 'Roboto Slab', // Set the font family to Roboto
      fontSize: 10, // Adjust the font size as needed
    },
    thumb: {
    backgroundColor: '#790096', // Set the thumb color to #404040
  },
  track: {
    backgroundColor: '#790096', // Set the track color to #404040
  },
  };

const marks = [
    {
      value: 1,
      label: 'Premier League',
    },
    {
      value: 2,
      label: 'Championship',
    },
    {
      value: 3,
      label: 'League One',
    },
    {
      value: 4,
      label: 'League Two',
    },
  ];


export interface InputSliderProps {
  title: string
  min_value: any;
  step_size: number;
  max_value: any;
  default_value: any;
  onChange: (axisType:number) => void;
}

const SliderSelector: React.FC<InputSliderProps> = ({
  title,
  min_value,
  step_size,
  max_value,
  onChange
}) => {

  const [value, setValue] =  React.useState<number | string | Array<number | string>>(
    500,
  );


  const handleSliderChange = (event: any, newValue: any ) => {
    setValue(newValue);
    onChange(newValue)
  };



  return (
    <Box sx={{ width: "80%" }}>
      <Typography id="input-slider"  gutterBottom sx={styles.title}>
        {title}
      </Typography>
        <Grid item xs>
          <Slider
            value={typeof value === 'number' ? value : 0}
            onChange={handleSliderChange}
            aria-labelledby="input-slider"
            min={min_value}
            max={max_value}
            step={step_size}
            marks={marks}
            sx={{
                '& .MuiSlider-markLabel': styles.markLabel, // Apply the custom styles to the mark labels
                '& .MuiSlider-thumb': styles.thumb, // Apply the custom styles to the thumb
                '& .MuiSlider-track': styles.track, // Apply the custom styles to the track
              }}
          />
        </Grid>
    </Box>
  );
}

export default SliderSelector;
